const AUTH_IS_AUTHENTICATED_UPDATED = (state, isAuthenticated) => {
  state.isAuthenticated = isAuthenticated
}

const AUTH_USER_PROFILE_UPDATED = (state, userProfile) => {
  state.userProfile = userProfile
}

const AUTH_IS_IMPERSONATING_UPDATED = (state, isImpersonating) => {
  state.isImpersonating = isImpersonating
}

const AUTH_CURRENT_IMPERSONATED_USER_UPDATED = (state, username) => {
  state.currentImpersonatedUser = username
}

const AUTH_IS_ADMIN_UPDATED = (state, isAdmin) => {
  state.isAdmin = isAdmin
}

const AUTH_MEMBER_ID_UPDATED = (state, memberId) => {
  state.memberId = memberId
}

const AUTH_USER_ID_UPDATED = (state, userId) => {
  state.userId = userId
}

const AUTH_IS_TWO_FACTOR_REQUIRED_UPDATED = (state, isTwoFactorRequired) => {
  state.isTwoFactorRequired = isTwoFactorRequired
}

const AUTH_IS_AUTH_LOADING_UPDATED = (state, isAuthLoading) => {
  state.isAuthLoading = isAuthLoading
}

const FEDERATED_AUTH_PROVIDERS_UPDATED = (state, providers) => {
  state.authProviders = providers
}

const AUTH_REDIRECT_URL_UPDATED = (state, redirectUrl) => {
  state.redirectUrl = redirectUrl
}

export default {
  AUTH_IS_AUTHENTICATED_UPDATED,
  AUTH_USER_PROFILE_UPDATED,
  AUTH_IS_IMPERSONATING_UPDATED,
  AUTH_CURRENT_IMPERSONATED_USER_UPDATED,
  AUTH_IS_ADMIN_UPDATED,
  AUTH_MEMBER_ID_UPDATED,
  AUTH_USER_ID_UPDATED,
  AUTH_IS_TWO_FACTOR_REQUIRED_UPDATED,
  AUTH_IS_AUTH_LOADING_UPDATED,
  FEDERATED_AUTH_PROVIDERS_UPDATED,
  AUTH_REDIRECT_URL_UPDATED,
}
